/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewPhoneAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function NewPhoneAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/NewPhone/Content/NewPhoneAction",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let newPhoneIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'new_phone',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceS}
 block={true}
 type="secondary"
 data="new_phone"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Form/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Form/Content'))}
 disabled={newPhoneIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Create New Phone"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}